import styled from "styled-components";

export const DescargarContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 55px;
  padding-bottom: 30px;
  background-color: #188edd;
`;
export const DescargarH2 = styled.h2`
  color: #fff;
  font-size: 35px;
  padding-bottom: 70px;
`;
export const DownloadLink = styled.a`
  width: 320px;
  height: 127px;
  padding-top: 5px;
  margin-bottom: 30px;
`;
export const DownloadImg = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;
